import type { RenderLink } from '@ui/web/utils'
import { getStaticAssetUrl } from '@helper/utils/file'

interface EmptyProps {
  sentCollectionId?: string
  /** When provided with libraryHref, the empty state uses this for the "Jelajahi Perpustakaan" CTA. */
  renderLink?: RenderLink
}

export function Empty({ sentCollectionId, renderLink }: EmptyProps) {
  return (
    <div className='srd:w-full srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-2 srd:h-fit srd:min-h-[40dvh] srd:col-span-full'>
      <img src={getStaticAssetUrl('illustration/foam.png')} alt='' width={60} height={60} draggable={false} />

      <h6 className='srd:text-neutrals-white'>Belum ada buku di Koleksi ini</h6>

      {sentCollectionId ? (
        <p className='srd:text-neutrals-white'>Guru / orang tua kamu belum memasukkan buku ke koleksi ini</p>
      ) : renderLink ? (
        renderLink({ children: 'Jelajahi Perpustakaan', className: 'srd:w-fit srd:h-fit' })
      ) : null}
    </div>
  )
}
